import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {ServiceCategoryService} from "@modules/service/services/service-category.service";
import {ServiceCategoryApi} from "@modules/service/api/service-category.api";
import {ServiceService} from "@modules/service/services/service.service";
import {ServiceSupportedCountryService} from "@modules/service/services/service-supported-country.service";

@Injectable({
  providedIn: 'root'
})
export class ServiceCategoryInitializerEffects {
  initServiceCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.serviceCategoryApi.get$()),
      tap(entities => {
        let serviceCategories = entities ?? []

        this.serviceCategoryService.dispatchSetEntities(serviceCategories);
        this.serviceService.dispatchSetEntities(serviceCategories.map(item => item.services).flat())
        this.serviceSupportedCountryService.dispatchSetEntities(serviceCategories.map(service => service.serviceSupportedCountries).flat())
      }),
      catchError(e => {
        console.error(e);

        this.serviceCategoryService.dispatchClearEntitiesAction()
        this.serviceService.dispatchClearEntitiesAction()
        this.serviceSupportedCountryService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    protected readonly actions$: Actions,
    protected readonly serviceCategoryApi: ServiceCategoryApi,
    protected readonly serviceCategoryService: ServiceCategoryService,
    protected readonly serviceService: ServiceService,
    protected readonly serviceSupportedCountryService: ServiceSupportedCountryService
  ) {
  }
}
